package horcrux.common.utils

import io.ktor.util.logging.KtorSimpleLogger
import io.ktor.util.logging.Logger

interface AppLogger {
    val logger: Logger
        get() = KtorSimpleLogger(this::class.simpleName.toString())
}
